import { momentLocalizer } from 'react-big-calendar'
import moment from 'moment'

import dashboardIcon from 'assets/icon/dashboard-icon.svg'
import heartIcon from 'assets/icon/heart-icon.svg'
import notificationIcon from 'assets/icon/notification-icon.svg'
import settingsIcon from 'assets/icon/settings-icon.svg'
// import euroIcon from '../assets/icon/euro-icon.svg'
import bitcoinIcon from '../assets/icon/bitcoin-icon.svg'
import ethereumIcon from '../assets/icon/ethereum-icon.svg'
import tetherIcon from '../assets/icon/tether-icon.svg'

export const STUDENT_ROLE = 'student'
export const TUTOR_ROLE = 'tutor'

export const navLinks = (isTutor, isLoggedIn) => {
  return [
    {
      label: 'Find Tutors',
      href: '/findtutor',
      isVisible: !isTutor && isLoggedIn,
    },
    {
      label: 'Shop',
      href: '/marketplace',
      isVisible: true,
    },
    {
      label: 'Jobs',
      href: '/jobs',
      isVisible: true,
    },
  ]
}

export const proctoringErrors = {
  FACE_CENTER_ERROR: 'FACE_CENTER_ERROR',
  MULTI_FACE_ERROR: 'MULTI_FACE_ERROR',
  NO_FACE_ERROR: 'NO_FACE_ERROR',
  NO_CAMERA_ERROR: 'NO_CAMERA_ERROR',
  NOISE_ERROR: 'NOISE_ERROR',
  TAB_SWICH_ERROR: 'TAB_SWICH_ERROR',
}

export const toolBarLinks = (role) => {
  return [
    {
      icon: dashboardIcon,
      href: role === STUDENT_ROLE ? '/student' : '/tutor',
      isVisible: true,
    },
    {
      icon: heartIcon,
      href: '/favourites',
      isVisible: role === TUTOR_ROLE,
    },
    {
      icon: settingsIcon,
      href: role === STUDENT_ROLE ? '/student/settings' : '/tutor/settings',
      isVisible: true,
    },
    {
      icon: notificationIcon,
      href: '/notifications',
      isVisible: true,
    },
  ]
}

export const dashboardLinks = (role) => {
  return [
    {
      label: 'Statistic',
      href: `/${role}/statistic`,
      icon: 'statistics',
      isVisible: true,
    },
    {
      label: 'Calendar',
      href: `/${role}/calendar`,
      icon: 'calendar',
      isVisible: true,
    },
    {
      label: 'Map',
      href: `/${role}/map`,
      icon: 'globus',
      isVisible: role === TUTOR_ROLE,
    },
    {
      label: 'Trading',
      href: `/${role}/trading`,
      icon: 'candlestick',
      isVisible: role === TUTOR_ROLE,
    },
  ]
}

export const getTradingTabs = (role) => {
  return [
    {
      href: `/${role}/trading`,
      label: 'Buy/Sell',
      exact: true,
    },
    {
      href: `/${role}/trading/market`,
      label: 'Market',
    },
    {
      href: `/${role}/trading/assets`,
      label: 'Assets',
    },
  ]
}

export const weekDays = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']

export const interfaceLanguages = [
  { value: 'English', label: 'English' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'French', label: 'French' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Vietnamise', label: 'Vietnamise' },
]

export const languageLevels = [
  { label: 'Native', value: 'native' },
  { label: 'Fluent', value: 'fluent' },
  { label: 'Basic', value: 'basic' },
]

export const genders = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
  { label: 'Prefer not to say', value: 'O' },
]

export const advanceOptions = [{ label: '1 month in advance', value: 1 }]

export const media = {
  xl: '(max-width: 1279px)',
  cursorPointer: '(pointer: fine)',
}

export const imagePrefix = 'https://backend-staging.apolop2p.com'

export const localizer = momentLocalizer(moment)

export const priceTypes = [
  {
    label: 'Hourly',
    value: 'hourly',
  },
  {
    label: 'Part Time',
    value: 'part-time',
  },
  {
    label: 'Full Time',
    value: 'full-time',
  },
  {
    label: 'Project',
    value: 'project',
  },
]

export const displayNameOptions = [
  {
    label: 'Use my real name',
    value: 'real_name',
  },
  {
    label: 'Use my nickname',
    value: 'nickname',
  },
]

export const displayLastNameOptions = [
  {
    label: 'Display my last name',
    value: 'display',
  },
  {
    label: "Don't display my last name",
    value: 'no_display',
  },
]

export const dateFormats = [
  { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
  { label: 'M/D/YY', value: 'M/D/YY' },
  { label: 'D/M/YY', value: 'D/M/YY' },
  { label: 'Month DD, YYYY', value: 'Month DD, YYYY' },
  { label: 'YY/MM/DD', value: 'YY/MM/DD' },
]

export const topUpAmounts = [
  {
    icon: '/assets/icon/topUp/lite.svg',
    title: 'Lite',
    ETH: {
      value: '0,031',
      equal_to: 50,
    },
    BTC: {
      value: '0,062',
      equal_to: 100,
    },
    Tether: {
      value: '0,062',
      equal_to: 100,
    },
    EUR: {
      value: '50',
    },
    discount: 3,
    price: 50,
    discounted_price: 47.5,
    best_choice: false,
  },
  {
    icon: '/assets/icon/topUp/essentials.svg',
    title: 'Essentials',
    ETH: {
      value: '0,046',
      equal_to: 75,
    },
    BTC: {
      value: '0,062',
      equal_to: 100,
    },
    Tether: {
      value: '0,062',
      equal_to: 100,
    },
    EUR: {
      value: '75',
    },
    discount: 5,
    price: 75,
    discounted_price: 67.5,
    best_choice: false,
  },
  {
    icon: '/assets/icon/topUp/pro.svg',
    title: 'Pro',
    ETH: {
      value: '0,062',
      equal_to: 100,
    },
    BTC: {
      value: '0,062',
      equal_to: 100,
    },
    Tether: {
      value: '0,062',
      equal_to: 100,
    },
    EUR: {
      value: '100',
    },
    discount: 7,
    price: 100,
    discounted_price: 93,
    best_choice: true,
  },
  {
    icon: '/assets/icon/topUp/pro.svg',
    title: 'Ultimate',
    ETH: {
      value: '0,31',
      equal_to: 500,
    },
    BTC: {
      value: '0,062',
      equal_to: 500,
    },
    Tether: {
      value: '0,062',
      equal_to: 500,
    },
    EUR: {
      value: '500',
    },
    discount: 10,
    price: 500,
    discounted_price: 450,
    best_choice: true,
  },
]

export const topUpTabs = ['Credit Card', 'Cryptocurrencies']

export const topUpPaymentMethodIcons = ['visa', 'mastercard', 'bitcoin', 'ethereum', 'tether']

export const cryptoPaymentNetworks = [
  {
    value: 'erc20',
    label: 'ERC20',
    description: 'ETHEREUM',
  },
  {
    value: 'trc20',
    label: 'TRC20',
    description: 'TRON',
  },
  {
    value: 'mainnet',
    label: 'MAINNET',
    description: 'MAINNET',
  },
]

export const cryptoPaymentCurrencies = [
  {
    value: 'BTC',
    label: 'Bitcoin',
    icon: bitcoinIcon,
  },
  {
    value: 'ETH',
    label: 'Ethereum',
    icon: ethereumIcon,
  },
  {
    value: 'Tether',
    label: 'Tether',
    icon: tetherIcon,
  },
]

export const faq = [
  {
    question: "What if I don't know which category I should choose?",
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
  {
    question: 'Can I pay for my credits with a cryptocurrency?',
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
  {
    question: 'What is your cancellation policy?',
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
  {
    question: 'What if I will not like the tutor. Can I make a refund?',
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
  {
    question: 'I want to become a tutor. What should I do for this?',
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
  {
    question: 'How many classes do I need to get expertise in any type?',
    answer:
      'You can get a free Intro class in any one of the categories to understand if it suites you. You also have the option of talking to the tutor before starting the class.',
  },
]

export const footerSections = [
  {
    title: 'Company',
    links: [
      { label: 'Tutors', link: '/findtutor' },
      { label: 'Job Posts', link: '/jobs' },
      { label: 'About Us', link: '/' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Disclaimer', link: '/disclaimer' },
      { label: 'Terms of Use', link: '/terms-of-use' },
      { label: 'Tutor Terms of Use', link: '/tutor-terms-of-use' },
      { label: 'FAQ', link: '/faq' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', link: '/privacy-policy' },
      { label: 'Cookie Policy', link: '/cookie-policy' },
      { label: 'Cancellation & Refund Policy', link: '/cancellation-and-refund-policy' },
      { label: 'Copywriting Policy', link: '/copyright-policy' },
    ],
  },
]

export const classLevels = [
  {
    value: 'expert',
    label: 'Expert',
  },
  {
    value: 'intermediate',
    label: 'Intermediate',
  },
  {
    value: 'beginner',
    label: 'Beginner',
  },
]

export const cancelClassReasons = [
  {
    value: 'reason1',
    label: 'Schedule conflict (I have another task planned for this time).',
  },
  {
    value: 'reason2',
    label: "I'm not feeling well",
  },
  {
    value: 'reason3',
    label: 'I changed my mind. I no longer need to learn this class.',
  },
  {
    value: 'reason6',
    label: 'Another reason (emergency, familial responsibility, etc.)',
  },
]
